import React from 'react';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { primary } from './mbApi';
import { BriefForm } from './BriefForm';

export const BriefDrawer = ({ open, setOpen, ibId, onCreated, draft, onDraftDone }) => (
  <Sheet open={open} onOpenChange={setOpen}>
    <SheetContent side="right" className="mb-scope w-full sm:max-w-3xl overflow-y-auto" data-testid="mb-brief-drawer">
      <SheetHeader className="text-left mb-4">
        <SheetTitle className={primary}>Buat Brief</SheetTitle>
        <SheetDescription>
          Isi borang (atau baca dari PDF). &quot;Simpan draf&quot; = status Kajian; &quot;Sedia untuk diserah&quot; = Brief Ready. Tutup panel ni tak buang input — draf disimpan di peranti ini.
        </SheetDescription>
      </SheetHeader>
      {open && <BriefForm ibId={ibId} draft={draft} onDraftDone={onDraftDone} onCreated={(w) => { setOpen(false); onCreated(w); }} />}
    </SheetContent>
  </Sheet>
);
